var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['preloader', { 'active': _vm.working }]},[_c('div',{staticClass:"indeterminate"})])
}
var staticRenderFns = []

export { render, staticRenderFns }